import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 12h12","key":"svg-0"}],["path",{"d":"M17 16l4 -4l-4 -4","key":"svg-1"}],["path",{"d":"M12 3a9 9 0 1 0 0 18","key":"svg-2"}]]

const IconArrowLeftFromArc = createReactComponent('outline', 'arrow-left-from-arc', 'ArrowLeftFromArc', __iconNode);

export default IconArrowLeftFromArc;